import { ButtonCSSStyleImpl } from '../button/buttoncss';
import { Colors } from '../../../utils/resources/colors';
// import { Fonts } from '../../../utils/resources/fonts';
import { BaseContext } from '../../../utils/basecontext';

export class BurmeseAlertButtonCSSStyle extends ButtonCSSStyleImpl
{
    private color:string;
    constructor(context:BaseContext, color:string)
    {
        super(context);
        this.color=color;
    }
    getWrapperCSSStyle(): object 
    {
       return {
        position: 'relative', 
        height: '40px', 
        width: '100%', 
        cursor: "pointer",
        outline:'none'

      };
    }
    getButtonStyle():object{
        return{
            width:'100%',
            height: '40px',
            float: 'left', 
            borderRadius: '3px',
            outline:'none',
            overflow: 'hidden',
            backgroundColor: this.getResources().getColor(Colors.color_5),
            cursor: "pointer",
            border: 'none',
            alignContent: 'center',
            alignItems: "center",
            justifyContent: "center",

        };
    }

    getButtonText():object
    {
        return{
            color:this.color, 
            fontSize: "9px", 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            paddingTop: "5px",
            // width: "118px",
            // textTransform: "uppercase",
            cursor: "pointer"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/alert/burmesealertbuttoncss.tsx